import { ApplicationConfig, importProvidersFrom, provideZoneChangeDetection, isDevMode, LOCALE_ID } from '@angular/core';
import { provideRouter } from '@angular/router';
import { appRoutes } from './app.routes';
import { HttpClient, provideHttpClient, withInterceptors } from '@angular/common/http';
import { NgxsModule } from '@ngxs/store';
import { provideServiceWorker } from '@angular/service-worker';
import { MissingTranslationHandler, TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { createCustomMissingTranslationHandler, createTranslateLoader } from './app.component';
import { BalloonsState } from '../shared/balloons-state/balloons.state';
import { EventsState } from '../shared/events-state/events.state';
import '@angular/common/locales/global/de-CH';
import { CustomHttpErrorInterceptor } from '@balloon-race-fullstack-monorepo/dbr-common';
import { ApiModule } from '@balloon-race-fullstack-monorepo/dbr-rest-api';
import { ENVIRONMENT } from '../environments/environment';


export const appConfig: ApplicationConfig = {
  providers: [
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(appRoutes),
    provideHttpClient(withInterceptors([CustomHttpErrorInterceptor])),
    importProvidersFrom(
      TranslateModule.forRoot({
        missingTranslationHandler: {
          provide: MissingTranslationHandler,
          useFactory: createCustomMissingTranslationHandler,
        },
        loader: {
          provide: TranslateLoader,
          useFactory: createTranslateLoader,
          deps: [HttpClient],
        },
      }),
      NgxsModule.forRoot(
        [BalloonsState, EventsState],
        {
          // developmentMode: !environment.production,
          selectorOptions: {
            suppressErrors: false,
            injectContainerState: false,
          },
        },
      ),
    ), provideServiceWorker('ngsw-worker.js', {
      enabled: !isDevMode(),
      registrationStrategy: 'registerWhenStable:30000',
    }),
    {
      provide: LOCALE_ID,
      useValue: 'de-CH',
    },
    importProvidersFrom(ApiModule.forRoot({ rootUrl: ENVIRONMENT.API.BASE_URL }))
  ],
};
